export const basePath = (processId: string) => `/api/v2/process/${processId}/draft`;

let tempDraftStepIdCounter = 0;
export function mintTempDraftStepId(): string {
  tempDraftStepIdCounter += 1;
  return `temp-draft-step-${Date.now()}-${tempDraftStepIdCounter}`;
}

let tempDraftEventIdCounter = 0;
export function mintTempDraftEventId(): string {
  tempDraftEventIdCounter += 1;
  return `temp-draft-event-${Date.now()}-${tempDraftEventIdCounter}`;
}

let tempDraftNoteIdCounter = 0;
export function mintTempDraftNoteId(): string {
  tempDraftNoteIdCounter += 1;
  return `temp-draft-note-${Date.now()}-${tempDraftNoteIdCounter}`;
}

/**
 * Mint a 24-char hex id that passes `Types.ObjectId.isValid` on the backend.
 * Used to pre-assign `_id` to records we'll immediately reference in a
 * follow-up call (e.g. a freshly-appended decision rule the very next
 * `connect` needs to target) without round-tripping to the server first.
 * Mongo's `ensureRuleIds` preserves valid pre-set ids, so the minted id
 * becomes the canonical one on write.
 */
export function mintObjectIdHex(): string {
  const bytes = new Uint8Array(12);
  crypto.getRandomValues(bytes);
  let out = '';
  for (const byte of bytes) out += byte.toString(16).padStart(2, '0');
  return out;
}
